import React from 'react';

import ActionToolbar from './ActionToolbar';
import MessageDetails from './MessageDetails';
import Message from './Message';
import ReplyForm from './ReplyForm';

const ConversationViewer = () => (
  <div className="flex flex-col h-full">
    <ActionToolbar />
    <MessageDetails />
    <Message />
    <ReplyForm />
  </div>
);

export default ConversationViewer;
